import { PHASE } from "../routeConfig";
import { InsuranceProducts } from "../constants";
export default function getShoppingIntentConfig(products) {
    var shoppingIntentConfig = [
        {
            has: function (products) {
                return products.includes(InsuranceProducts.Auto) &&
                    products.includes(InsuranceProducts.Home);
            },
            text: "auto and home",
            nextRoute: function () { return PHASE.SELECT_AUTO_ISSUER; },
        },
        {
            has: function (products) { return products.includes(InsuranceProducts.Auto); },
            text: "auto",
            nextRoute: function () { return PHASE.SELECT_AUTO_ISSUER; },
        },
        {
            has: function (products) { return products.includes(InsuranceProducts.Home); },
            text: "home",
            nextRoute: function () { return PHASE.HOME_SELECT_ISSUER; },
        },
        {
            has: function (products) { return products.includes(InsuranceProducts.Business); },
            text: "business",
            nextRoute: function () { return PHASE.CALL_TO_SHOP; },
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Motorcycle); },
            text: "motorcycle / ATV / boat / RV",
            nextRoute: function () { return PHASE.CALL_TO_SHOP; },
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Landlord); },
            text: "landlord",
            nextRoute: function () { return PHASE.CALL_TO_SHOP; },
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Life); },
            text: "life",
            linkOut: "https://ethos-life.sjv.io/savvy",
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Renters); },
            text: "renters",
            linkOut: "https://www.epremiuminsurance.com/DirectToConsumerPartner.aspx?IRISAccountID=uqnPVhzxjr0%3d&TopLevelIRISAccountID=DKkpwg9hFl8%3d&FCCode=FC06591",
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Pet); },
            text: "pet",
            linkOut: "https://figopetinsurance.com/?p=L3U3S#get-a-quote",
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Cyber); },
            text: "cyber / identity theft",
            linkOut: "https://firstconnect.sites.blinkinsured.com/quote/cyber?properties.agentId=FC06591&properties.channel=cross-sale",
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.Flood); },
            text: "flood",
            linkOut: "https://neptuneflood.com/consumer-app/?source=kySmGEYwSjgW5IMSb0pwUItUJYbkd5OnXYRInntBKrxq6gvXtHpPdaOqY%2Bnwxasr8Dx5R468FM6Ob7S9kMQan%2FErq0wwH%2B8o1WsUi03pMuw%3D",
        },
        {
            has: function (prods) { return prods.includes(InsuranceProducts.CellPhone); },
            text: "cell phone",
            linkOut: "https://portal.boltinsurance.com/prod/ui/firstconnect/enrollment?agentid=FC06591",
        },
    ];
    return shoppingIntentConfig.find(function (_a) {
        var has = _a.has;
        return has(products);
    });
}
